"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rtrim_1 = __importDefault(require("./rtrim"));
/**
 * Convert the current a dot notation string to compound input name
 * my.input.name >> my[input][name]
 *
 * @param   {string} string
 * @returns {string}
 */
function toInputName(string) {
    var e_1, _a;
    if (!string)
        return '';
    if (!string.includes('.'))
        return string;
    var namesList = string.split('.'), mainName = namesList.shift() || '';
    try {
        for (var namesList_1 = __values(namesList), namesList_1_1 = namesList_1.next(); !namesList_1_1.done; namesList_1_1 = namesList_1.next()) {
            var name_1 = namesList_1_1.value;
            var outBrackets = '';
            if (name_1.endsWith('[]')) {
                name_1 = rtrim_1.default(name_1, '[]');
                outBrackets = '[]';
            }
            mainName += "[" + name_1 + "]" + outBrackets;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (namesList_1_1 && !namesList_1_1.done && (_a = namesList_1.return)) _a.call(namesList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return mainName;
}
exports.default = toInputName;
//# sourceMappingURL=toInputName.js.map